// Usage to always autofocus:     <input type="text" use:autofocus_directive={true} />
// Usage to optionally autofocus: <input type="text" use:autofocus_directive={my_boolean_variable} />

export default (node: HTMLElement, should_autofocus: boolean) => {
	should_autofocus && setTimeout(() => node.focus(), 0)
}
